import { type FC, type PropsWithChildren } from "react";
import { createContext } from "react";

import { type CanvasRuntimeManager } from "./CanvasRuntimeManager";

export type RuntimeProviderProps = {
	runtime: CanvasRuntimeManager | null;
};

export const RuntimeContext = createContext<CanvasRuntimeManager | null>(null);

/**
 * RuntimeProvider
 * @description provides a runtime for cells rendered by ProseMirror
 */
export const RuntimeProvider: FC<PropsWithChildren<RuntimeProviderProps>> = ({
	runtime,
	children,
}) => {
	return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
};
